import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { UserEntityMappingApi } from '../api/user-entity-mapping.api';
import { UserEntityMapping, UserEntityMappingData } from '../../../interfaces/masters/user-entity-mapping';

@Injectable()
export class UserEntityMappingService extends UserEntityMappingData {

  constructor(private api: UserEntityMappingApi) {
    super();
  }

  list(url: string): Observable<any> {
    return this.api.list(url);
  }

  getById(url: string): Observable<UserEntityMapping> {
    return this.api.getById(url);
  }

  create(url: string, data: UserEntityMapping): Observable<any> {
    return this.api.add(url, data);
  }

  update(url: string, data: UserEntityMapping): Observable<any> {
    return this.api.update(url, data);
  }

}
